import React from "react";
import Amount from "../../features/deposit/Amount";
import { currency } from "../../constants/constants";
import DepositTable from "../../features/deposit/DepositTable";
import { Box, Card, Typography } from "@mui/material";
import "./deposit.css";
import { useState } from "react";
import { useEffect } from "react";
import Web3 from "web3";
import { ABI, ABI2, ContractAddress, ContractAddress2 } from "../../Web3_interact/configuration";
import Currency from "../../features/deposit/Currency";
import { errorToast } from "../../constants/ShowToast";
import { useDispatch, useSelector } from "react-redux";
import { getDepositAmount } from "../../redux/features/getDepositAmountSlice";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import HomeIcon from "@mui/icons-material/Home";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BadgeIcon from "@mui/icons-material/Badge";
import Loader from "../../constants/loader/Loader";
import { STORAGE_KEYS, setToStorage } from "../../constants/Storage";
const Deposit = () => {
  const [currencyType, setCurrencyType] = useState("ETH");
  console.log(currencyType, 'currency');
  const [contract, setContract] = useState("");
  const [contract2, setContract2] = useState("");
  const [usdt, setUsdt] = useState("");
  const dispatch = useDispatch();
  const [totalEth, setTotalEth] = useState(0);
  const [lockedEth, setLockedEth] = useState([]);
  const [unLockedEth, setunLockedEth] = useState([]);
  const [type, setType] = useState("Locked");
  
  useEffect(() => {
    const init = async () => {
      if (window.ethereum !== "undefined") {
        try {
          await window.ethereum.request({ method: "eth_requestAccounts" });
          const web3 = new Web3(window.ethereum);
          const contractInstance = new web3.eth.Contract(ABI, ContractAddress);
          setContract(contractInstance);
          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          const account = accounts[0];
          setToStorage(STORAGE_KEYS.walletAddress, account || null);
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        console.error("Please install MetaMask or any other Web3 provider.");
      }
    };

    init();
  }, []);

  useEffect(() => {
    const initApprove = async () => {
      if (window.ethereum !== "undefined") {
        try {
          console.log("running");
          await window.ethereum.request({ method: "eth_requestAccounts" });
          const web3 = new Web3(window.ethereum);
          const contractInstance2 = new web3.eth.Contract(ABI2, ContractAddress2);
          console.log('contractInstance2: ', contractInstance2);
          console.log(contractInstance2, "contractInstace222");
          setContract2(contractInstance2);
          const accounts = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          const account = accounts[0];
          setToStorage(STORAGE_KEYS.walletAddress, account || null);
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        console.error("Please install MetaMask or any other Web3 provider.");
      }
    };

    initApprove();
  }, []);



  useEffect(() => {
    dispatch(getDepositAmount())
      .then((result) => {
        if (result?.payload?.statusCode === 200) {
          console.log(
            result?.payload?.data?.totalEth[0]?.total,
            "depositdattatatata"
          );
          setTotalEth(result?.payload?.data?.totalEth[0]?.total || 0);
          setLockedEth(result?.payload?.data?.Collateral || []);
          setunLockedEth(result?.payload?.data?.UnlockedCollateral || []);
        }
      })
      .catch((error) => {
        console.log(error, "errrrerrrrr====");
      });
  }, []);



  //check usdt balance
  const CheckUsdtBalance = async () => {
    console.log('enter');
    try {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const account = accounts[0];
      console.log(account,'8888888');
      let balance = await contract.methods.checkBankBalance().call({from: account});
      console.log( "balance======calll", balance);
      setUsdt(balance);
    } catch (error) {
      console.log(error, "errorz");
      errorToast(error?.data?.message);
    }
  };

  //check eth balance
const CheckEthBalance = async () => {
  console.log('enter eth999999 ');
  try {
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const account = accounts[0];
    console.log(account,'8888888');
    if(contract){
      let balance = await contract.methods.checkEthBalance().call({from: account});
      console.log( "balance=checkEthBalance=====calll", balance);
      setUsdt(balance);
    }
  
  } catch (error) {
    console.log(error, "errorz");
    errorToast(error?.data?.message || "");
  }
};
  
  //widthdraw usdt 
  const widthdrawUsdt = async (amount) => {
    console.log(amount,'====widthdrawUsdt=amountt==');
    try {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const account = accounts[0];
      const gas = await contract.methods
        .withdrawUsdt(amount)
        .estimateGas({ from: account });
      const transaction = await contract.methods
        .withdrawUsdt(amount)
        .send({ from: account, gas: gas });
      console.log(transaction, "transaction withdraw usdt");
    } catch (error) {
      console.log(error);
      errorToast(error?.data?.message || "");
    }
  }

  //eth withdraw
  const WithdrawSecurityAmount = async (amount) => {
    console.log('WithdrawSecurityAmount called', amount);
    try {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const account = accounts[0];
      const gas = await contract.methods
        .withdrawETH(amount)
        .estimateGas({ from: account });
      const transaction = await contract.methods
        .withdrawETH(amount)
        .send({ from: account, gas: gas });
      console.log(transaction, "withdrawETH");
    } catch (error) {
      console.log(error);
      errorToast(error?.data?.message || "");
    }
  };

  //deposit usdt
  const DepositFund = async (amount) => {
    console.log(amount, "deposit amount");
    try {
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      const account = accounts[0];
      console.log(account, "userAcc");

      // const gas2 = await contract2.methods
      // .approve(amount)
      // .estimateGas({ from: account });
      // console.log('gas2: ', gas2);
      // const gas2 = await contract2.methods
      // .approve(amount)
      // .estimateGas({ from: account });
      // console.log('gas: ', gas2);
      const transferApproval = await contract2.methods.approve(ContractAddress,amount).send({from:account});
      console.log('=================transferApproval: ', transferApproval);
      if(transferApproval){
        const gas = await contract.methods
        .depositUsdt(amount)
        .estimateGas({ from: account });

      const transaction = await contract.methods
        .depositUsdt(amount)
        .send({ from: account, gas: gas});
        console.log(transaction, "transaction");
      }
    
    } catch (error) {
      console.log(error, "errrrururur");
      errorToast(error?.data?.message || "");
    }
  };

  useEffect(() => {
   
    CheckEthBalance()
  }, [contract])
  
 
  const load = useSelector((state) => state?.EthApi?.status);
  const usdtInt = parseInt(usdt, 10);
  return (
    <div className="deposit-fluid ">
      <Loader isLoad={load} />
      <div className="container">
        <div className="wrap-deposit">
          <div className="cur-rency">
            <div className="deposit-lft">
              <div className="deposit-amount-cont">
                <Amount
                usdt={Number(usdt)}
                  amt={currencyType === "ETH" ? totalEth : usdtInt}
                  Withdraw={
                    currencyType === "ETH"
                      ? WithdrawSecurityAmount
                      : widthdrawUsdt
                  }
                  // WithdrawFund ={widthdrawFund}
                  currency={currencyType}
                  deposit={DepositFund}
                />
              </div>
              <div className="deposit-currency-cont">
                <h2>Currency</h2>
                {/* currency */}
                <div className="deposit-currency_cont">
                  <Card
                    variant="outlined"
                    onClick={() => {setCurrencyType('ETH'); CheckEthBalance()}}

                    sx={{
                      display: "flex",
                      alignItems: "center",
                      height: "61px",
                      width: "329px",
                      padding: "0px 10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <figure
                        style={{
                          height: "33px",
                          width: "33px",
                          marginRight: "15px",
                        }}
                      >
                        {" "}
                        <img
                          src="/static/images/2b5c7d80-7bcd-4cfb-8bd9-d1760a752afc 1.png"
                          alt="eth"
                        />{" "}
                      </figure>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: "20px",
                            fontWeight: "700px",
                          }}
                        >
                          ETH
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            margin: "0px 0px 0px 0px ",
                            fontWeight: "400px",
                          }}
                        >
                          Ethereum
                        </Typography>
                      </Box>
                    </div>
                    <input
                      type="radio"
                      className="deposit-radio"
                      value="ETH"
                      checked={currencyType === "ETH"}
                    />
                  </Card>
                  <Card
                    variant="outlined"
                    onClick={(e) => {
                      setCurrencyType("USDT")
                      CheckUsdtBalance();
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      height: "61px",
                      width: "329px",
                      padding: "0px 10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <figure
                        style={{
                          height: "33px",
                          width: "33px",
                          marginRight: "15px",
                        }}
                      >
                        {" "}
                        <img
                          src="/static/images/ethereum.png"
                          alt="usdt"
                        />{" "}
                      </figure>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                        }}
                      >
                        <Typography
                          variant="h5"
                          sx={{
                            fontSize: "20px",
                            fontWeight: "700px",
                          }}
                        >
                          USDT
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            margin: "0px 0px 0px 0px ",
                            fontWeight: "400px",
                          }}
                        >
                          TetherUS
                        </Typography>
                      </Box>
                    </div>
                    <input
                      type="radio"
                      className="deposit-radio"
                      value="USDT"
                      checked={currencyType === "USDT"}
                    />
                  </Card>
                </div>

                {/* currency end */}
              </div>
            </div>
            <div className="deposit-rt">
              <div className="deposit-hr-cont">
                <div
                  style={{
                    width: "770px",
                    // height: "230px",
                    color: "#fff",
                  }}
                >
                  <div className="hr-content">
                    <div className="balace_display">
                      <h2>
                        {type === "Locked"
                          ? "Locked Ethereum"
                          : "Unlocked Ethereum"}
                      </h2>
                      {type === "Locked"
                        ? lockedEth?.map((item) => {
                            return (
                              <div key={item?._id}>
                                <div className="loan_bal">
                                  {item._id === "HOME" ? (
                                    <HomeIcon />
                                  ) : item._id === "CAR" ? (
                                    <DirectionsCarIcon />
                                  ) : (
                                    <BadgeIcon />
                                  )}
                                  <h5>{item?._id || ""} :</h5>
                                  <p>{item?.total || 0} WEI</p>
                                </div>
                              </div>
                            );
                          })
                        : unLockedEth?.map((item) => {
                            return (
                              <div key={item?._id}>
                                <div className="loan_bal">
                                  {item._id === "HOME" ? (
                                    <HomeIcon />
                                  ) : item._id === "CAR" ? (
                                    <DirectionsCarIcon />
                                  ) : (
                                    <BadgeIcon />
                                  )}
                                  <h5>{item?._id || ""} :</h5>
                                  <p>{item?.total || 0} WEI</p>
                                </div>
                              </div>
                            );
                          })}
                    </div>

                    <div className="rev_buttons">
                      <div
                        className={
                          type === "Locked" ? "r_btn active_dis" : "r_btn"
                        }
                        onClick={() => setType("Locked")}
                      >
                        <h6>Locked Etherium</h6>
                        <LockIcon />
                      </div>
                      <div
                        className={
                          type === "Unlocked" ? "r_btn active_dis" : "r_btn"
                        }
                        onClick={() => setType("Unlocked")}
                      >
                        <h6>Unlocked Etherium</h6>
                        <LockOpenIcon />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hr-img">
                  <figure
                    style={{
                      height: "100%",
                      width: "395px",
                    }}
                  >
                    <img
                      src="/static/images/Artwork.png"
                      style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                      alt=""
                    ></img>
                  </figure>
                </div>
              </div>
              <div className="deposit-table">
                <DepositTable />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Deposit;
